import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, hasMarketingConsent, isTrackedPath, loadAnalytics, setAnalyticsAllowed } from '../lib/metaPixel';

// Con consenso, solo su pagine non sensibili: Google Analytics e PageView del Pixel a ogni cambio pagina.
// Se il consenso arriva dopo (click su "Accetta"), parte sulla pagina corrente.
export const MetaPixelTracker = () => {
  const location = useLocation();
  const counted = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    const tracked = isTrackedPath(path);
    setAnalyticsAllowed(path);
    if (!tracked) return undefined;
    const run = () => {
      loadAnalytics();
      if (counted.current !== path && trackPageView()) counted.current = path;
    };
    if (hasMarketingConsent()) {
      run();
      return undefined;
    }
    const poll = setInterval(() => {
      if (hasMarketingConsent()) {
        run();
        clearInterval(poll);
      }
    }, 500);
    const stop = setTimeout(() => clearInterval(poll), 120000);
    return () => {
      clearInterval(poll);
      clearTimeout(stop);
    };
  }, [location.pathname]);

  return null;
};
